import requests from "./httpService";

const DashboardService = {
    getAllDashboardData: async () =>{
        return requests.get("/dashboard");
    }
}

export default DashboardService;